(() => {
  const originalLabels = new WeakMap();
  function updateThemeHeading() {
    const params = new URL(location.href).searchParams;
    const label = params.get('mcm_theme')?.trim();
    const query = params.get('q');
    const valid = label && label.length <= 160 && query && params.get('mcm_theme_q') === query;
    document.querySelectorAll('[data-mcm-theme-search-heading]').forEach(heading => {
      if (!originalLabels.has(heading)) originalLabels.set(heading, heading.textContent);
      heading.textContent = valid ? label : originalLabels.get(heading);
    });
  }
  updateThemeHeading();
  document.addEventListener('shopify:section:load', updateThemeHeading);
  window.addEventListener('popstate', updateThemeHeading);
})();
